import { IComponentLoggingData } from '@faire/web-api--source/indigofair/data/IComponentLoggingData';
import { IGetSDUIFilteredComponentsRequest } from '@faire/web-api--source/indigofair/data/IGetSDUIFilteredComponentsRequest';
import { IGetSDUINavigationTreeRequest } from '@faire/web-api--source/indigofair/data/IGetSDUINavigationTreeRequest';
import { ISectionStyle } from '@faire/web-api--source/indigofair/data/ISectionStyle';
import { ITextElement } from '@faire/web-api--source/indigofair/data/ITextElement';

export namespace IFilterablePaginatedSection {
  export namespace IFilterBarConfiguration {
    /**
     * Return an instance of IFilterBarConfiguration with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (
      partial?: Partial<IFilterBarConfiguration>
    ): IFilterBarConfiguration =>
      ({
        ...(partial ?? {}),
      }) as IFilterBarConfiguration;
  }

  export interface IFilterBarConfiguration {
    title: ITextElement | undefined;
    subtitle: ITextElement | undefined;
    logging_data: IComponentLoggingData | undefined;
  }

  /**
   * Return an instance of IFilterablePaginatedSection with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IFilterablePaginatedSection>
  ): IFilterablePaginatedSection =>
    ({
      ...(partial ?? {}),
    }) as IFilterablePaginatedSection;
}

export interface IFilterablePaginatedSection {
  get_s_d_u_i_filtered_components:
    | IGetSDUIFilteredComponentsRequest
    | undefined;
  get_s_d_u_i_navigation_tree_request:
    | IGetSDUINavigationTreeRequest
    | undefined;
  /**
   * DEPRECATED, please set the SectionStyle in the parent section instead.
   * @deprecated
   */
  section_style: ISectionStyle | undefined;
  /**
   * Show filters in the section. If this is not provided, client should hide filters.
   */
  filter_bar_configuration:
    | IFilterablePaginatedSection.IFilterBarConfiguration
    | undefined;
}
